import React, { memo } from 'react';
import { Box } from '@chakra-ui/react';

import TransferOverview from './TransferOverview';
import EventLogs from './EventLogs';

const ActiveTransfer = memo(({
  transfer,
  link,
  transferOverviewStyle,
  transferOverviewProps,
  eventLogsStyle,
  eventLogsProps,
  renderingMultiple = false,
  ...props
}) => {
  return (
    <Box
      d="flex"
      flexDirection={['column', 'column', 'column', 'row']}
      justifyContent={['space-between', 'space-between', 'space-between', 'flex-start']}
      {...props}
    >
      <TransferOverview
        transfer={transfer}
        mb="32px"
        maxWidth="700px"
        link={link}
        style={transferOverviewStyle}
        height="fit-content"
        {...transferOverviewProps}
      />
      <EventLogs
        transfer={transfer}
        pl={[0, 0, 0, '64px']}
        style={eventLogsStyle}
        maxWidth="700px"
        // Arbitrarily small max height in row flexDirection so that the left column isnt displaced
        maxHeight={!renderingMultiple ? ['auto', 'auto', 'auto', '200px'] : 'auto'}
        overflowY={!renderingMultiple ? 'visible' : 'auto'}
        {...eventLogsProps}
      />
    </Box>
  );
});

export default ActiveTransfer;
